<template>
    <div class="banner">
        <div class="banner_box center">
            <h1>{{$t('banner_title')}}</h1>
            <p class="info">{{$t('banner_info')}}</p>
            <div class="buy_box flex_box">
                <div>
                    <div class="box">
                        <p class="title">{{$t('monthlyPlan_title')}}</p>
                        <p class="price"><span>$0.064</span>{{$t('monthlyPlan_displayPricePerCredit')}}</p>
                        <span class="btn" plan="2">{{$t('buy_now')}}</span>
                        <div class="credits">
                            <div plan="1" class="flex_box">
                            <i></i>
                            <span>50 {{$t('monthlyPlan_plan1_credits')}}</span>
                            <span>$6.00</span>
                            <span>$0.120{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="2" class="flex_box active">
                            <i></i>
                            <span>250 {{$t('monthlyPlan_plan1_credits')}}<i></i></span>
                            <span>$16.00</span>
                            <span>$0.064{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="3" class="flex_box">
                            <i></i>
                            <span>500 {{$t('monthlyPlan_plan1_credits')}}</span>
                            <span>$26.00</span>
                            <span>$0.052{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="4" class="flex_box">
                            <i></i>
                            <span>1000 {{$t('monthlyPlan_plan1_credits')}}</span>
                            <span>$46.00</span>
                            <span>$0.046{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                    <ul>
                        <li v-html="$t('monthlyPlan_feature1')"></li>
                        <li v-html="$t('monthlyPlan_feature2')"></li>
                        <li v-html="$t('monthlyPlan_feature3')"></li>
                    </ul>
                    </div>
                </div>
                <div>
                    <div class="box">
                        <p class="title">{{$t('oneTimePurchase_title')}}</p>
                        <p class="price"><span>$0.120</span>{{$t('monthlyPlan_displayPricePerCredit')}}</p>
                        <span class="btn" plan="7">{{$t("buy_now")}}</span>
                        <div class="credits">
                            <div plan="5" class="flex_box">
                            <i></i>
                            <span>100 {{$t('oneTimePurchase_plan5_credits')}}</span>
                            <span>$26.00</span>
                            <span>$0.260{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="6" class="flex_box">
                            <i></i>
                            <span>250 {{$t('oneTimePurchase_plan5_credits')}}</span>
                            <span>$46.00</span>
                            <span>$0.184{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="7" class="flex_box active">
                            <i></i>
                            <span>500 {{$t('oneTimePurchase_plan5_credits')}}<i></i></span>
                            <span>$66.00</span>
                            <span>$0.120{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                            <div plan="8" class="flex_box">
                            <i></i>
                            <span>1000 {{$t('oneTimePurchase_plan5_credits')}}</span>
                            <span>$96.00</span>
                            <span>$0.096{{$t('monthlyPlan_displayPricePerCredit')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="list">
                    <ul>
                        <li>{{$t('oneTimePurchase_feature1')}}</li>
                        <li>{{$t('oneTimePurchase_feature2')}}</li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
        <i></i>
        <i></i>
    </div>
    <div class="payment center">
        <h2>{{$t('payment_title')}}</h2>
        <img width="925" height="51" src="../assets/images/pricing/payment-methods.png" loading="lazy" alt="Payment Methods">
    </div>
    <div class="faq center">
    <h2>{{$t('faq_title')}}</h2>
    <div class="faq_box">
        <div class="active">
        <p class="title">{{$t('faq_question1_title')}}</p>
        <p class="info">{{$t('faq_question1_info')}}</p>
        </div>
        <div>
        <p class="title">{{$t('faq_question2_title')}}</p>
        <p class="info">{{$t('faq_question2_info')}}</p>
        </div>
        <div>
        <p class="title">{{$t('faq_question3_title')}}</p>
        <p class="info">{{$t('faq_question3_info')}}</p>
        </div>
        <div>
        <p class="title">{{$t('faq_question4_title')}}</p>
        <p class="info">{{$t('faq_question4_info')}}</p>
        </div>
    </div>
    </div>
    <div class="choose center">
        <h2>{{$t('Why Choose Tipard')}}</h2>
        <div class="choose_container flex_box">
            <div class="choose_item">
            <img src="../assets/images/pricing/safe.svg" alt="Safe" />
            <p class="title">{{$t('whyChoose_reason1_title')}}</p>
            <p class="info">{{$t('whyChoose_reason1_info')}}</p>
            </div>
            <div class="choose_item">
            <img src="../assets/images/pricing/professional.svg" alt="Professional" />
            <p class="title">{{$t('whyChoose_reason2_title')}}</p>
            <p class="info">{{$t('whyChoose_reason2_info')}}</p>
            </div>
            <div class="choose_item">
            <img src="../assets/images/pricing/service.svg" alt="Service" />
            <p class="title">{{$t('whyChoose_reason3_title')}}</p>
            <p class="info">{{$t('whyChoose_reason3_info')}}</p>
            </div>
            <div class="choose_item">
            <img src="../assets/images/pricing/money-back.svg" alt="Money Back" />
            <p class="title">{{$t('whyChoose_reason4_title')}}</p>
            <p class="info">{{$t('whyChoose_reason4_info')}}</p>
            </div>
            <div class="choose_item">
            <img src="../assets/images/pricing/users.svg" alt="Users" />
            <p class="title">{{$t('whyChoose_reason5_title')}}</p>
            <p class="info">{{$t('whyChoose_reason5_info')}}</p>
            </div>
            <div class="choose_item">
            <img src="../assets/images/pricing/countries.svg" alt="Countries" />
            <p class="title">{{$t('whyChoose_reason6_title')}}</p>
            <p class="info">{{$t('whyChoose_reason6_info')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    mounted(){
        $('.buy_box>div .credits>div').click(function(){
            $(this).addClass('active').siblings().removeClass('active')
            $(this).parents('.box').find('.price span').html($(this).find('span').eq(2).html().split('/')[0])
            $(this).parents('.box').find('.btn').attr('plan',$(this).attr('plan'))
        })
        $('.faq_box div .title').click(function(){
            $(this).parent().toggleClass('active').siblings().removeClass('active')
        })
        // 购买
        if(location.hostname=='www.tipard.com'){
            var paddle_vendor=137567;
        }else{
            Paddle.Environment.set('sandbox');
            var paddle_vendor=570;
        }
        Paddle.Setup({
            vendor: paddle_vendor,
            eventCallback: function(data) {
                console.log(data);
                $('.buy_box .btn').removeClass('load');
                if (data.event === 'Checkout.PaymentComplete') {
                    isbuy=1;
                }
                if(data.event === 'Checkout.Close'&&isbuy){
                    $('.maskRights').show();
                    $('.buySuccess').show().siblings().hide();
                    if(getCookie('user')){
                        $('.buySuccess .Member').show().siblings('.info').hide();
                    }else{
                        $('.buySuccess .noMember').show().siblings('.info').hide();
                    }
                }
            }
        });
        // 请求购买链接
        $('.buy_box .btn').click(function(){
            if($(this).attr('class').indexOf('load')>-1){
                return false;
            }
            checkout($(this));
        });
        var gateway = 4;
        function checkout(that){
            var data={
                e_id:murmur,
                gateway:gateway,
                plan_id:that.attr('plan'),
            }
            that.addClass('load')
            $.post(
                post_url+"subscription/checkout",
                data,
                function(data){
                    that.removeClass('load')
                    error_fn(data.error,that);
                    switch(data.error){
                        case 0:
                            if(gateway==4){
                                // 2checkout
                                (function (document, src, libName, config,data) {
                                    var data=getUrlkey(data.url_gateway)
                                    var script             = document.createElement('script'); 
                                    script.src             = src; 
                                    script.async           = true; 
                                    script.id              ='buy2checkout'
                                    var firstScriptElement = document.getElementsByTagName('script')[0]; 
                                    script.onload          = function () {
                                        var isbuy=0;
                                        for (var namespace in config) {
                                            if (config.hasOwnProperty(namespace)) {
                                                window[libName].setup.setConfig(namespace, config[namespace]);
                                            } 
                                        } 
                                        window[libName].register();
                                        TwoCoInlineCart.products.add({
                                            code: data.prod,
                                            quantity: data.qty,
                                        });
                                        try{
                                            if(data.test){
                                                TwoCoInlineCart.cart.setTest(true);
                                            }
                                        }catch(e){
                                            console.log(e)
                                        }
                                        if(data.lock){
                                            TwoCoInlineCart.cart.setCartLockedFlag(true)
                                        }else{
                                            TwoCoInlineCart.cart.setCartLockedFlag(false);
                                        }
                                        if(data['empty-cart']){
                                            TwoCoInlineCart.cart.setReset(true)
                                        }else{
                                            TwoCoInlineCart.cart.setReset(false)
                                        }
                                        TwoCoInlineCart.cart.setExpiration(data.expiration)
                                        TwoCoInlineCart.cart.setSignature(data.signature)
                                        // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                        TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                        TwoCoInlineCart.cart.checkout();
                                        TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                            console.log('cart:opened')
                                        })
                                        TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                            if(isbuy){
                                                $('.maskRights').show();
                                                if(getCookie('user')){
                                                    $('.buySuccess.Member').show().siblings().hide();
                                                    gaPush('buy_login','true')
                                                }else{
                                                    $('.buySuccess.noMember').show().siblings().hide();
                                                    gaPush('buy_login','false')
                                                }
                                            }
                                        })
                                        TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                            isbuy=1;
                                            gaPush('buy_success','')
                                        })
                                    }; 
                                    firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                                })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                            }else{
                                isbuy=0;
                                Paddle.Checkout.open({
                                    override: data.url_gateway
                                });
                            }
                            break
                        case 25301:
                            that.removeClass('load')
                            error(i18n[lang].error_25301);
                            break;
                        case 25302:
                            that.removeClass('load')
                            error(i18n[lang].error_25302);
                            break;
                        case 25303:
                            that.removeClass('load')
                            error(i18n[lang].error_25303);
                            break;
                        case 25304:
                            that.removeClass('load')
                            error(i18n[lang].error_25304);
                            break;
                        case 25305:
                            that.removeClass('load')
                            error(i18n[lang].error_25305);
                            break;
                        case 25306:
                            that.removeClass('load')
                            error(i18n[lang].error_25306);
                            break;
                    }
                }
            ).fail(function(xhr){
                overtime(25399);
            });
        }
        // url参数解析
        function getUrlkey(url) {
            var params = {};
            var urls = url.split("?");
            var arr = urls[1].split("&");
            for (var i = 0, l = arr.length; i < l; i++) {
            var a = arr[i].split("=");
            params[a[0]] = a[1];
            }
            return params;
        }
    }
}
</script>
<style scoped>
.center{max-width: 1200px;margin: auto;box-sizing: border-box;}
h2{font-size: 36px;color: #333;line-height: 48px;text-align: center;}
.banner{
  padding-top: 68px;
  text-align: center;
  position: relative;
}
.banner>i:nth-of-type(1){
  width: 452px;
  height: 317px;
  background: url(../assets/images/pricing/top-banner-left.svg);
  position: absolute;
  left: 0px;
  top: 129px;
  z-index: -1;
}
.banner>i:nth-of-type(2){
  width: 365px;
  height: 268px;
  background: url(../assets/images/pricing/top-banner-right.svg);
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: -1;
}
.banner::before{
  clear: both;
  content: "";
  width: 100%;
  height: 446px;
  background: #E3F5FF;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0;
  z-index: -1;
  border-radius: 10px 10px 0 0;
}
.banner_box{
  overflow: visible;
}
.banner h1{
  font-size: 42px;
  color: #333;
  line-height: 50px;
  font-weight: bold;
}
.banner_box>.info{
  max-width: 870px;
  width: 100%;
  margin: 26px auto 0;
  font-size: 20px;
  color: #333;
  line-height: 32px;
}
.buy_box{
  margin: 65px auto 0px;
  max-width: 964px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.buy_box>div{
  margin-top: 20px;
  background: #FFFFFF;
  box-shadow: 2px 7px 20px 0px rgba(0,0,0,0.2);
  border-radius: 30px;
  max-width: 432px;
  width: 100%;
  padding-top: 40px;
}
.buy_box>div .box{
  padding-left: 40px;
  padding-right: 40px;
}
.buy_box>div .title{
  font-size: 28px;
  color: #222;
  font-weight: bold;
  line-height: 42px;
}
.buy_box>div .price{
  margin-top: 20px;
  line-height: 46px;
  font-size: 20px;
  color: #777;
}
.buy_box>div .price span{
  font-size: 42px;
  color: #FF0000;
  font-weight: bold;
}
.buy_box>div .btn{
  min-width: 220px;
  display: inline-block;
  height: 56px;
  line-height: 56px;
  background: #FF6F36;
  border-radius: 40px 40px 40px 40px;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  margin-top: 12px;
  position: relative;
}
.buy_box>div .btn:hover{
  cursor: pointer;
}
.buy_box>div .btn.load{
  color: transparent;
}

.buy_box>div .btn.load::before{
  opacity: 1;
}
.buy_box>div .btn::before{
  clear: both;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background: url(../assets/images/loading.svg);
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
  animation: rotate 1s infinite linear;
  opacity: 0;
}
/* 旋转 */
@-webkit-keyframes rotate {0% {-webkit-transform: rotate(0deg)}100% {-webkit-transform: rotate(360deg)}}
@-moz-keyframes rotate {0% {-moz-transform: rotate(0deg)}100% {-moz-transform: rotate(360deg)}}
@-o-keyframes rotate {0% {-o-transform: rotate(0deg)}100% {-o-transform: rotate(360deg)}}

.buy_box>div .credits{
  margin-top: 20px;
}
.buy_box>div .credits>div{
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E2E2E2;
  cursor: pointer;
}
.buy_box>div .credits i{
  width: 14px;
  height: 14px;
  background: url(../assets/images/pricing/selection-mark.svg);
  display: block;
  margin-right: 10px;
}
.buy_box>div .credits>div.active i{
  background-position-y: -14px;
}
.buy_box>div .credits span{
  font-size: 16px;
  color: #222;
  line-height: 24px;
  display: inline-block;
  white-space: nowrap;
}
.buy_box>div .credits span:nth-of-type(1){
  width: 154px;
  margin-right: 10px;
}
.buy_box>div .credits span:nth-of-type(1) i{
  display: inline-block;
  background: url(../assets/images/pricing/recommended-plan.svg);
  width: 21px;
  height: 21px;
  vertical-align: -2px;
  margin-left: 5px;
}
.buy_box>div .credits span:nth-of-type(2){
  width: 58px;
}
.buy_box>div .credits span:nth-of-type(3){
  margin-left: auto;
}
.buy_box>div .list{
  background: #E3F5FF;
  margin-top: 24px;
  padding: 20px 40px;
  border-radius:  0 0 30px 30px;
}
.buy_box>div .list ul{
  display: inline-block;
  text-align: left;
  font-size: 16px;
  color: #222;
  line-height: 24px;
  min-height: 112px;
}
.buy_box>div .list ul li{
  margin-bottom: 8px;
  position: relative;
  padding-left: 14px;
}
.buy_box>div .list ul li::before{
  clear: both;
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: 9px;
  left: 0px;
  background: #222;
}
.buy_box>div .list ul li span{
  font-weight: bold;
}
.buy_box>div .list ul li:last-child{
  margin-bottom: 0px;
}

.buy_box>div:first-child{
  border: 9px solid #4B80FF;
}
h2{
  font-size: 40px;
  line-height: 50px;
  color: #222;
  font-weight: bold;
}
.payment{
  margin-top: 90px;
  
}
.payment img{
  margin: 56px auto 0;
}
.faq{
  margin-top: 100px;
}
.faq_box{
  margin-top: 56px;
}
.faq_box div{
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px solid #D9D9D9;
  padding-left: 38px;
  padding-right: 56px;
}
.faq_box div .title{
  font-size: 24px;
  color: #222;
  line-height: 24px;
  font-weight: bold;
  position: relative;
  padding-right: 26px;
  cursor: pointer;
}
.faq_box div .title::before{
  clear: both;
  content: "";
  background: url(../assets/images/pricing/arrow.svg);
  width: 21px;
  height: 11px;
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
}
.faq_box div.active .title::before{
  background-position-y: -11px;
}
.faq_box div .info{
  margin-top: 20px;
  font-size: 16px;
  color: #222;
  line-height: 24px;
  display: none;
}
.faq_box div.active .info{
  display: block;
}
/*choose*/
.choose{width: 100%;margin:80px auto 68px;text-align: center;}
.choose_container{margin-top: 24px;justify-content: center;}
.choose_item{margin:0 0;box-sizing: border-box;max-width: 385px;width: 100%;padding:32px 30px;border-radius: 24px;}
.choose_item img{display: block;margin: 0 auto;}
.choose_item .title{margin: 24px auto 12px;font-size: 24px;font-weight: bold;color: #222222;line-height: 24px;}
.choose_item .info{margin: 0 auto ;font-size: 16px;color: #222222;line-height: 24px;}

@media screen and (max-width:1200px){
  .header_new div.menu.active ul li.nav-special{
    display: none;
  }
  h2{
    font-size: 36px;
    line-height: 42px;
  }
  .center{
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .buy_box{
    justify-content: space-around;
  }
  .buy_box>div .box{
    padding-left: 20px;
    padding-right: 20px;
  }
  .faq_box div{
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media screen and (max-width:900px) {
    .payment img{
        max-width: 100%;
        height: auto;
    }
    .buy_box>div .list ul{
        min-height: auto;
    }
}
@media screen and (max-width:768px) {
    .banner h1{
        font-size: 32px;
        line-height: 36px;
    }
    .banner{
        padding-top: 48px;
    }
    h2{
        font-size: 32px;
        line-height: 40px;
    }
    .buy_box>div .list{
        padding: 20px 20px;
    }
    .buy_box{
        margin: 20px auto 0;
    }
    .banner_box>.info{
        font-size: 18px;
    }
    .payment{
        margin-top: 50px;
    }
    .faq,.choose{
        margin-top: 50px;
    }
}
@media screen and (max-width:630px){
  .buy_box>div .credits span:nth-of-type(3){
    display: none;
  }
  .buy_box>div .credits span:nth-of-type(2){
    margin-left: auto;
  }
}
@media screen and (max-width:414px) {
    h2{
        font-size: 24px;
        line-height: 32px;
    }
    .faq_box{
        margin-top: 30px;
    }
    .faq_box div .title{
        font-size: 18px;
    }
}
@media screen and (max-width:1200px){
    .banner i{display: none;}
}
</style>